const queries = {
  setNavigation: (data: GQL.INavigationInput) => ({
    query: `
        mutation {
            setNavigation(
                options:{
                    action: "${data.action}",
                    creditor: ${data.creditor ? `"${data.creditor}"` : null},
                    dealType: ${data.dealType || null},
                    plan: ${data.plan || null},
                    dealValue: ${data.dealValue || null},
                    delay: ${data.delay || null}
                }
            ) {
                id
            }
        }           
        `,
  }),

  setNegotiation: (data: GQL.IInsertNegotiationModel) => ({
    query: `
        mutation {
            setNegotiation(
                negotiation:{
                    creditor: "${data.creditor}",
                    dealType: ${data.dealType},
                    plan: ${data.plan},
                    dealValue: ${data.dealValue},
                    delay: ${data.delay},
                    databaseId: ${data.databaseId},
                    dealId: ${data.dealId}
                }
            )
        }`,
  }),

  setPayment: (data: GQL.IPaymentInput) => ({
    query: `
        mutation {
            setPayment(
                options: {
                    paymentType: ${data.paymentType},
                    billetType: ${data.billetType},
                    creditor: "${data.creditor}",
                    portion: ${data.portion},
                    plan: ${data.plan},
                    value: ${data.value},
                    dueDate: "${data.dueDate}",
                    billetNumber: ${data.billetNumber}
                }
            )
        }`,
  }),

  setError: (data: GQL.ISetErrorOnMutationArguments, idConfig: string) => ({
    query: `
        mutation {
            setError(
                options: {
                    actionId: ${data.options.actionId},
                    errorMessage: "${data.options.errorMessage}",
                    srcId: ${data.options.srcId || 0},
                    idConfig: "${idConfig}"
                }
            ){
                session
                date
                actionId
                errorMessage
                srcId
                idConfig
            }
        }`,
  }),
};

export default queries;
